// Photo file names: surface + running number (docs/SCHEMA.md "Photos on
// SharePoint" — "Walls 01.jpg"). The area is the SharePoint folder, so the
// number runs per name within one area. Photos not of one surface are "General".

export const GENERAL_PHOTO_NAME = 'General';
/** The area's own perspective shot (#437): "Feature photo 01.jpg". */
export const AREA_PHOTO_NAME = 'Feature photo';
const NUMBER_DIGITS = 2;
const EXTENSION = '.jpg';

const escapeRegExp = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * The next free name for `prefix` among the area's existing photo names: one
 * past the highest number already used, so a gap never gets reused.
 */
export function nextPhotoName(prefix: string, existing: readonly string[]): string {
  const pattern = new RegExp(`^${escapeRegExp(prefix)} (\\d+)\\${EXTENSION}$`, 'i');
  const highest = existing.reduce((max, name) => {
    const match = pattern.exec(name);
    return match ? Math.max(max, Number(match[1])) : max;
  }, 0);
  return `${prefix} ${String(highest + 1).padStart(NUMBER_DIGITS, '0')}${EXTENSION}`;
}

/**
 * The same photo under the next free name, when its own turned out to be
 * taken (another device's photo has it): "Walls 01.jpg" → "Walls 04.jpg".
 */
export function renamedPhoto(fileName: string, existing: readonly string[]): string {
  const prefix = fileName.replace(new RegExp(` \\d+\\${EXTENSION}$`, 'i'), '');
  return nextPhotoName(prefix, [...existing, fileName]);
}
